import React from 'react'
import cx from 'classnames'
import Grid from '@mui/material/Grid'
import { CaThemeProvider } from 'components/redesign/CaThemeProvider'
import { AnnouncementsSkeleton, StoriesSkeleton } from 'pages/dashboard/Skeleton'
import Box from '@mui/material/Box'
import AnnouncementsHeader from 'pages/dashboard/AnnouncementsHeader'

const DashboardSkeleton = ({ isLogged = true, windowHeight, headerHeight = 118 }) => (
  <div
    className='w-100 overflow-y-auto bg-page-background flex justify-center scrolling-container flex-wrap'
    style={{ maxHeight: `${windowHeight - headerHeight}px` }}
  >
    <div className='grow-1 shrink-1 basis0 ph0 ma0'>
      <div className='h-100 mb8'>
        <div className='bg-page-background'>
          <div className={cx('layout-width-constraint bg-page-background', { 'pt0 pb8': isLogged, pv0: !isLogged })}>
            <CaThemeProvider>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={9}>
                  <div className='bt-thick bt--dark-cerulean'>
                    <StoriesSkeleton />
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={3}>
                  <ContentPanelsWrapperSkeleton />
                </Grid>
              </Grid>
            </CaThemeProvider>
          </div>
        </div>
      </div>
    </div>
  </div>
)

const ContentPanelsWrapperSkeleton = () => {
  return (
    <div className='bg-page-background'>
      <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
        <AnnouncementsHeader />
      </Box>
      <>
        <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
          <AnnouncementsSkeleton maxHeight={1712} />
        </Box>
        <Box sx={{ display: { xs: 'block', lg: 'none' } }}>
          <AnnouncementsSkeleton maxHeight={595} />
        </Box>
      </>
    </div>
  )
}

export default DashboardSkeleton
